import * as React from "react";
import {SVGProps} from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={25}
        height={25}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M21.395 13.388c-.812 1.936-3.654 1.936-5.403 1.843.25 1.343.5 3.654.093 4.497-.343.75-1.093 1.25-1.998 1.343h-.156c-.844 0-1.593-.344-2-1.093-1.842-2.842-3.685-4.841-4.34-5.497H3.654c-.905 0-1.655-.75-1.655-1.655V5.33c0-.905.75-1.655 1.655-1.655H6.592s2.904-1.25 5.496-1.437c.75-.03.75 0 1.155 0 2.25 0 4.342.5 5.84 1.5 2.78 1.936 3.624 6.933 2.312 9.65Zm-17.74-.562h1.656V5.33H3.655v7.496Zm14.43-7.652c-1.156-.75-2.999-1.25-4.904-1.25h-.687c-.219 0-.406 0-.625.032-2.373.281-3.467.625-3.997.843a2.187 2.187 0 0 0-.531.281l-.344.25v7.496h.687c.406 0 .812.156 1.156.5.656.75 2.592 2.842 4.56 5.809.156.25.406.343.655.343.25 0 .5-.062.656-.406.063-.25.063-1.561-.343-3.904l-.25-1.124c-.031-.188.094-.375.312-.375h1.53c1.156.063 3.592.063 3.998-.843.906-2.155.25-6.309-1.874-7.652Z"
            fill="currentColor"
        />
    </svg>
);

export default SvgComponent;
